import { Button, TextField } from "@mui/material";
import { CONNECTION_STATUS } from "pages/Admin/Whatsapp/WhatsappConnect";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import ChannelConnectionsAdminService from "services/admin/channelConnections";

interface TelegramConnectProps {
  channelConnection: any;
  refetch: () => void;
}
export const TelegramConnect = ({ channelConnection, refetch }: TelegramConnectProps) => {
  const tokenRef = useRef<HTMLInputElement>(null);

  const handleConnect = async () => {
    console.log("Подключение к Telegram");

    let value = tokenRef.current?.value;
    if (!value) {
      toast.error("Пожалуйста, введите токен Telegram");
      return;
    }
    value = value.trim();
    if (value.length !== 46) {
      toast.error("Пожалуйста, введите 46 символов токена Telegram");
      return;
    }

    const { data } = await ChannelConnectionsAdminService.connectTelegram(channelConnection.id);
    toast.success("Telegram подключен успешно!");
    refetch();
    console.log("data: ", data);
  };

  const updateToken = async () => {
    let value = tokenRef.current?.value;
    if (!value) {
      toast.error("Пожалуйста, введите токен Telegram");
      return;
    }
    value = value.trim();

    if (value.length !== 46) {
      toast.error("Пожалуйста, введите 46 символов токена Telegram");
      return;
    }

    try {
      await ChannelConnectionsAdminService.put(channelConnection.id, {
        accessToken: value,
      });
    } catch (error: any) {
      toast.error(`Ошибка при подключении Telegram: ${error?.message}`);
    }
  };

  const handleDisconnect = async () => {
    console.log("Отсоединение от Telegram");
    if (window.confirm("Вы уверены, что хотите отсоединить Telegram?")) {
      const { data } = await ChannelConnectionsAdminService.disconnectTelegram(
        channelConnection.id
      );
      toast.success("Telegram отсоединен успешно!");
      console.log("data: ", data);
      refetch();
    }
  };

  if (
    channelConnection?.connectionStatus === CONNECTION_STATUS.PENDING ||
    channelConnection?.connectionStatus === CONNECTION_STATUS.DISCONNECTED
  ) {
    return (
      <div className="flex flex-col gap-4">
        <div>Telegram не подключен. Пожалуйста, подключите Telegram.</div>
        <div className="flex flex-col gap-2">
          <TextField
            label="Token"
            inputRef={tokenRef}
            onKeyUp={updateToken}
            defaultValue={channelConnection?.token}
          />
          <Button variant="contained" color="primary" onClick={handleConnect}>
            Подключить Telegram
          </Button>
        </div>
      </div>
    );
  }
  return (
    <div>
      <div className="">
        <div className="mb-2 text-sm text-gray-500">
          External AccountID: {channelConnection?.externalAccountID}
        </div>
        <div className="mb-2 text-sm text-gray-500">
          External Account Username: {channelConnection?.externalAccountUserName}
        </div>
        <div className="mb-2 text-sm text-gray-500">
          External Account First Name: {channelConnection?.externalAccountFirstName}
        </div>
        <div className="mb-2 text-sm text-gray-500">
          Access Token: {channelConnection?.accessToken}
        </div>
        <div className="mb-2 text-sm text-gray-500">
          Webhook URL: {channelConnection?.webhookURL}
        </div>
        <div className="mt-4">
          <Button variant="outlined" color="error" onClick={handleDisconnect}>
            Отсоединить Telegram
          </Button>
        </div>
      </div>
    </div>
  );
};
